import { Component, OnInit } from '@angular/core';
import { Member } from '../../../_models';
import { ApiService, AlertService } from '../../../_services';

@Component({
  selector: 'app-gen-gold',
  templateUrl: './gen-gold.component.html',
  styleUrls: ['./gen-gold.component.scss']
})
export class GenGoldComponent implements OnInit {

  currentMember: Member;
  constructor(private apiService: ApiService,
    private alertService: AlertService
    ) {
    this.currentMember =  JSON.parse(localStorage.getItem("currentMember"));
   }

  ngOnInit() {
    
  }

  login(){
    this.apiService.ssoGenGoldLogin(this.currentMember.memberId, this.currentMember.currentProductId).subscribe(r=>{
      if(r.success){
          top.window.open( r.data.login_url, '_blank');
      }else{
          this.alertService.error(r.message);
      $('html, body').animate({
          scrollTop: ($('ng2-toasty').first().offset().top)
      },500);
      return;
      }
  });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/benefits/gen-gold/gen-gold.component.ts